import React from "react";
import { Download, Printer, Loader } from "lucide-react";

const PdfPreviewModal = ({
  pdfUrl,
  isGenerating,
  error,
  onDownload,
  onPrint,
  onRetry,
  quotationDetails,
}) => {
  if (isGenerating) {
    return (
      <div className="flex flex-col items-center justify-center py-20">
        <Loader size={48} className="animate-spin text-blue-600 mb-4" />
        <p className="text-slate-600 font-medium">Generating PDF...</p>
      </div>
    );
  }

  if (error || !pdfUrl) {
    return (
      <div className="p-10 text-center">
        <p className="text-red-500">{error || "No PDF generated"}</p>
        <button
          onClick={onRetry}
          className="mt-4 bg-blue-600 text-white px-4 py-2 rounded"
        >
          Retry
        </button>
      </div>
    );
  }

  return (
    <div className="flex flex-col h-[80vh]">
      {" "}
      {/* Give it a fixed height */}
      <div className="flex justify-end gap-2 p-4 border-b">
        <button
          onClick={onPrint}
          className="flex items-center gap-2 px-3 py-1 border rounded"
        >
          <Printer size={16} /> Print
        </button>
        <button
          onClick={onDownload}
          className="flex items-center gap-2 px-3 py-1 bg-green-600 text-white rounded"
        >
          <Download size={16} /> Download
        </button>
      </div>
      <div className="flex-1 bg-gray-200">
        <iframe
          src={pdfUrl}
          className="w-full h-full border-0"
          title="PDF Preview"
        />
      </div>
    </div>
  );
};

export default PdfPreviewModal;
